import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { BILLING_PATHS } from '../utils/paths';

// The billing landing tab. Overview replaces Your plan under `billing-ui-2026`, and the tab nav hides
// whichever the flag retires, so every "Plans & billing" link resolves here once.
export function useBillingLandingHref(): string {
  const isBillingUI2026Enabled = useFeatureFlag(AccountFeatureFlag.BillingUI2026);
  return isBillingUI2026Enabled ? BILLING_PATHS.overview : BILLING_PATHS.yourPlan;
}
